import { FaWhatsapp } from "react-icons/fa";
import "./FixedWhatsappBtn.css";
export default function FixedWhatsappBtn() {
  return (
    <a href="https://wa.me/+919967855616" className="fixed-whatsapp-icon">
      <FaWhatsapp />
    </a>
  );
}
